import { downgradeComponent } from '@angular/upgrade/static';

import { RemindersComponent } from '../ng2/profile/reminders/reminders.component.ts';

const dependencies = ['main'];

const profile = angular.module('profile', dependencies);

const autoload = require.context('.', true, /\.(html|json|woff|woff2|ttf|eot|svg|gif|png)$/);
const object = autoload.keys();
object.forEach((name) => {
  autoload(name);
});

profile
  .config(require('./config/routes.js'))

  .service('ProfileService', require('./services/profile-service.js'))

  .component('home', require(('./components/home.js')))

  .component('personalInformations', require(('./components/tabs/personal-informations/personal-informations.js')))
  .component('linkPatientForm', require(('./components/link-patient-form/link-patient-form.js')))
  .component('profile', require(('./components/tabs/profile.js')))
  .component('profileManagement', require(('./components/profile-management/profile-management.js')))

  .component('notificationManagement', require(('./components/tabs/notification-management/notification-management.js')))
  .component('changePassword', require(('./components/tabs/change-password/change-password.js')))
  .component('changeEmail', require(('./components/tabs/change-email/change-email.js')))

  .directive('reminders', downgradeComponent({
    component: RemindersComponent,
    inputs: [],
    outputs: [],
  }))

  .run(['$translate', '$translatePartialLoader', ($translate, $translatePartialLoader) => {
    $translatePartialLoader.addPart('profile');
    return $translate.refresh();
  },
  ]);

module.exports = profile;



// WEBPACK FOOTER //
// ./profile/profile.js